import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';

class Link extends React.Component {
  render() {
    const { to } = this.props;
    return /^https?:\/\//.test(to)
      ? <a href={to} {...this.props} rel="noopener noreferrer" target="_blank" />
      : <RouterLink {...this.props} to={`${to}`} />;
  }
}

export default Link;
